import { faList, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import { Search } from "react-bootstrap-icons";
import { useForm } from "react-hook-form";
import { searchPeople } from "../../store/api/CustomerApi";
import { useState } from "react";
import BihamtaTable from "../BihamtaTable";

const ModalSelectPerson = (props) => {
    const { popData, setPopData } = props;
    const { show, onSelect } = popData;
    const [list, setList] = useState({Data:[]});
    const { handleSubmit, register } = useForm();
    function close() {
        setPopData({
            show: false
        })
        if (onSelect) {
            onSelect(null);
        }
    }
    function select(row) {
        if (onSelect) {
            const {e,target,...selected} =row;
            onSelect(selected);
            setPopData({
                show: false
            })
        }
    }
    function search(data) {
        data.Take = 8;
        data.Skip = 0;
        setList("PENDING");
        searchPeople(data, setList);
    }
    const tableCols = [
        { colTitle: "نوع", colName: "PPersonType" },
        { colTitle: "نام و نام خانوادگی", colName: "PersonName", showInMobile: true },
        { colTitle: "کد ملی", colName: "NationalCode", showInMobile: true },
        { colTitle: "تلفن", colName: "Phone", showInMobile: true },
        { colTitle: "همراه", colName: "Mobile" },
        { colTitle: "نشانی", colName: "PersonAddress" }
    ]
    return (
        <Modal size="lg" show={show} onHide={() => { }}>
            <Modal.Header className="headerStyle">
                <span>
                    <FontAwesomeIcon icon={faList} size="lg" />&nbsp;
                    انتخاب شخص از لیست
                </span>
                <FontAwesomeIcon icon={faTimes} size="lg" onClick={close} />
            </Modal.Header>
            <Modal.Body className="bodyStyle">
                <form onSubmit={handleSubmit(search)}>
                    <Row className="rowBorder form-group">
                        <Col md={4}>
                            <Form.Control name="PersonName" ref={register({})} placeholder="نام شخص" />
                        </Col>
                        <Col md={4}>
                            <Form.Control name="NationalCode" ref={register({})} placeholder="کد ملی" />
                        </Col>
                        <Col md={4}>
                            <Form.Control name="Phone" ref={register({})} placeholder="تلفن" />
                        </Col>
                        <Col md={4}>
                            <Form.Control name="Mobile" ref={register({})} placeholder="شماره همراه" />
                        </Col>
                        <Col md={4}>
                            <Form.Control name="PersonAddress" ref={register({})} placeholder="نشانی" />
                        </Col>
                        <Col md={4}>
                            <select className="form-control" name="PersonType" ref={register({})}>
                                <option value="">نوع شخص </option>
                                <option value="PreCustomer">مشتری بالقوه</option>
                                <option value="Customer">مشتری</option>
                                <option value="Agent">نماینده</option>
                                <option value="Staff">تکنسین</option>
                                <option value="Personnel">پرسنل</option>
                            </select>
                        </Col>
                    </Row>
                    <Button className="group-Btn mt-2" type="submit"><Search size={17} />&nbsp;جستجوی شخص</Button>
                </form>
                <BihamtaTable columns={tableCols} dataList={list} rowClick={select} style={{whiteSpace:"nowrap"}} forceRowClickInMobile={true}/>
            </Modal.Body>
        </Modal>
    )

}
export default ModalSelectPerson;